module.exports = __webpack_public_path__ + "img/news2.3d52331b.png";